import { FC } from "react";

interface CardProps {
    children: React.ReactNode;
    borderColor: string;
    bgColor: string;
    minHeight: string;
    maxWidth?: string;
    grow?: boolean;
    center?: boolean;
    stretch?: boolean;
    mAuto?: boolean;
    loading?: boolean;
}
 
const Card: FC<CardProps> = ({children, borderColor, bgColor, minHeight, grow, center, maxWidth, mAuto, stretch}) => {
    return (
      <div
        className={`border-[1px]
                border-${borderColor}
                bg-${bgColor}
                min-h-${minHeight}
                ${maxWidth}
                ${mAuto ? "m-auto" : ""}
                ${grow ? "grow" : ""}
                ${stretch ? "flex items-stretch" : ""}
                ${center ? "flex justify-center items-center" : ""}
                mb-5
                w-full
                rounded-3xl`}
      >
        {children}
      </div>
    );
}
 
export default Card;